<template>
    <div>
        <div class="page page--checkout">
            <div class="h-container-checkout">
                <header class="page__heading page__heading--first">
                    <h1 class="page__heading-title h2">
                        <AppIcon modifier="cartheader"/>
                        Your Cart
                    </h1>
                </header>
            </div>
            <div class="h-container-checkout-a">
                <div class="h-checkout-grid" v-if="!loading">
                    <div class="h-checkout-left-col">
                        <CartDetails :order="order"/>
                    </div>
                    <div class="h-checkout-right-col">
                        <aside class="text h-sticky">
                            <CartSummary :order="order"/>
                            <CartCertificates/>
                        </aside>
                    </div>
                </div>
                <div v-else>
                    Cart is loading...
                </div>
            </div><!-- /.h-container -->
            <div class="page__block page__block--a">
                <div class="h-container-checkout">
                    <div class="grid">
                        <div class="grid__col--sm-6 grid__col--md-4">
                            <div class="text">
                                <h6>Frequently asked questions</h6>
                                <FaqAccordion/>
                            </div>
                        </div>
                        <div class="grid__col--sm-6 grid__col--md-4">
                            <CartBenefits/>
                        </div>
                    </div>
                    <a href="#" class="page__misc-back-btn">
                        <AppIcon modifier="arrow" class="page__misc-back-btn-icon"/>
                        Back to Start
                    </a>
                </div>
            </div>
        </div><!-- /.page-container -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CartSummary from '../../components/cart/CartSummary';
import AppIcon from '../../components/AppIcon';
import FaqAccordion from '../../components/FaqAccordion';
import CartDetails from '../../components/cart/CartDetails';
import CartBenefits from '../../components/cart/CartBenefits';
import CartCertificates from '../../components/cart/CartCertificates';

export default {
  components: {
    CartDetails,
    CartSummary,
    CartBenefits,
    CartCertificates,
    AppIcon,
    FaqAccordion,
  },
  mounted() {
    this.getUserDraftOrder();
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      order: 'cart/order',
    }),
  },
  methods: {
    getProductionTimes() {
      this.loading = true;
      this.$store.dispatch('categories/getProductionTimes')
        .finally(() => {
          this.loading = false;
        });
    },
    getUserDraftOrder() {
      this.loading = true;

      this.$store.dispatch('cart/init')
        .then(() => {
          this.getCompanyShipping();
          this.getProductionTimes();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCompanyShipping() {
      this.loading = true;

      this.$store.dispatch('users/getCompanyShipping')
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
